import Link from "./Link";
import styled from "styled-components";

import getStatColor from "../controllers/getStatColor";
import getMaxTime from "../controllers/getMaxTime";
import toMinsOrHours from "../controllers/toMinOrHours";
import getDateString from "../controllers/getDateString";
import { AiOutlineEdit } from "react-icons/ai";
import shadeColor from "../controllers/shadeColor";
import Select from "react-select";
import { useState } from "react";

export default function CustomSelect({ defaultValue, onChange, options }) {
  return (
    <Select
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          fontSize: "15px",
          paddingLeft: "5px",

          background: "var(--translucent)",
          border: "none",
        }),
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 15,
        paddingLeft: "25px",
        colors: {
          ...theme.colors,
          primary25: "var(--translucent)",
          neutral0: "var(--bgColor)",
          neutral5: "var(--bgColor)",
          neutral10: "var(--bgColor)",
          neutral20: "var(--translucentHard)",
          neutral30: "var(--color)",
          neutral40: "var(--color)",
          neutral50: "var(--color)",
          neutral60: "var(--color)",
          neutral70: "var(--color)",
          neutral80: "var(--color)",
          neutral90: "var(--color)",
        },
      })}
      value={defaultValue}
      onChange={onChange}
      options={options}
    />
  );
}
